import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { format } from "date-fns";
import { CircularProgress } from "@mui/material";
import QuotationListFilterModal from "./QuotationListFilterModal";
import ic_filter from "../utils/ic_filter.png";
import useApi from "../hooks/useApi";
import PaginationControls from "../components/lead_and_quotation/PaginationControls";
import ReusableTable from "../components/lead_and_quotation/TableListViewFull";

const WorkOrderApprovalListViewFull = (props) => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const [workOrderDetails, setWorkOrderDetails] = useState(null);

  const [currentWorkorderNumber, setCurrentWorkorderNumber] = useState(0);

  const [showDetailsOfWorkorder, setShowDetailsOfWorkorder] = useState(false);

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

  const userAccessGroup = currentUserObject[0].accessgrp;

  const initialFilterObject = {
    fromDate: "1900-01-01",
    toDate: todayDate,
    task_creator_id:
      userAccessGroup?.trim().toUpperCase() === "COORDINATOR"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    task_owner_id:
      userAccessGroup?.trim().toUpperCase() != "COORDINATOR" &&
      userAccessGroup?.trim().toUpperCase() != "ADMIN"
        ? empIDFromUserObjectInLocalStorage
        : "-",
    free_text: "-",
  };

  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [currentUserAccessGroup, setCurrentUserGroupAccess] = useState(null);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [quotationList, setQuotationList] = useState(null);
  const [quotationDetailsData, setQuotationDetailsData] = useState(null);
  const [quotationDetailsPopup, setQuotationDetailsPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const callAPI = () => {
    console.log("currentPageNumber ", currentPageNumber);

    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    if (!currentUserObject) {
      console.error("No user data found in localStorage");
      return;
    }

    const userAccessGroup = currentUserObject[0].accessgrp;

    console.log("currentUserDepartment:", currentUserDepartment);
    console.log("userAccessGroup:", userAccessGroup);

    fetchQuotationList(
      userAccessGroup,
      currentUserDepartment,
      initialFilterObject,
      empIDFromUserObjectInLocalStorage
    );
  };

  useEffect(() => {
    if (currentPageNumber) {
      callAPI();
    }
  }, [currentPageNumber]);

  const {
    request: requestQuotationList,
    loading: loadingQuotationList,
    error,
  } = useApi();
  const fetchQuotationList = async (
    userAccessGroup,
    currentUserDepartment,
    filterObjectFromModal,
    empIDFromUserObjectInLocalStorage
  ) => {
    console.log("filterObjectFrom Modal", filterObjectFromModal);

    setLoading(true);

    try {
      let url = "";

      if (userAccessGroup === "ADMIN" || "CADMIN") {
        url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/WorkorderApproval/-/${currentUserDepartment}`;
        console.log("url testing", url);
      }

      //   axios.get(url).then((res) => {
      //     console.log("Quotation List:", res.data);
      //     setQuotationList(res.data);
      //   });
      const response = await requestQuotationList({
        url: url,
        method: "GET",
        timeout: 5000,
      });
      console.log("Quotation List:", response);
      setQuotationList(response);
    } catch (error) {
      console.error("Error fetching quotations:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {};

  useEffect(() => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    console.log("User acces Group", userAccessGroup);
    setCurrentUserGroupAccess(userAccessGroup);
  }, []);

  const {
    request: requestToChangeStatus,
    loading: loadingToChangeStatus,
    error: errorChangeStatus,
  } = useApi();
  const callAPIToChangeStatus = async (quot_slNo, statusByAdmin) => {
    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );

    const currentUserfromLocalStorage = JSON.parse(
      localStorage.getItem("currentUser")
    );

    let currentUserEMPID = "-";

    if (currentUserfromLocalStorage) {
      console.log(
        "currentUserfromLocalStorage[0] ",
        currentUserfromLocalStorage[0]
      );
      currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
    } else {
      console.log(
        "currentUserfromLocalStorage[0] else",
        currentUserfromLocalStorage[0]
      );
    }

    const jsonObject = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "WORKORDER",
        DocNo: quot_slNo + "",
        deptno: currentUserDepartment,
        Status: statusByAdmin,
        Comments: "",
        UserID: currentUserEMPID?.trim(),
        created_on: format(new Date(), "yyyy-MM-dd"),
      },
    ];

    const jsonToSend = JSON.stringify(jsonObject);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/ProposalStatus`;

    // axios
    //   .post(apiUrl, jsonToSend, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   })
    //   .then((res) => {
    try {
      const response = await requestToChangeStatus({
        url: apiUrl,
        method: "POST",
        data: jsonToSend,
        config: {
          headers: {
            "Content-Type": "application/json",
          },
        },
        timeout: 5000,
      });
      if (response.result === "Saved") {
        alert("Saved");

        callAPI();
      } else {
        alert("Something went wrong");
      }
    } catch (err) {
      console.error("Error", err);
    }
  };

  const clickedOnDetails = (order_number) => {
    setShowDetailsOfWorkorder((prev) => !prev);
    setCurrentWorkorderNumber(order_number);
  };

  const closePopupClicked = () => {
    setShowDetailsOfWorkorder(false);
    setCurrentWorkorderNumber(0);
  };

  const {
    request: requestDetailsOfWorkorder,
    loading: loadingDetailsOfWorkorder,
    error: errorDetailsOfWorkorder,
  } = useApi();
  const callAPIToGetDetailsOfWorkorder = async () => {
    const currentUserDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/WorkorderDetails/${currentWorkorderNumber}/${currentUserDepartment}`;

    try {
      const response = await requestDetailsOfWorkorder({
        url: apiUrl,
        method: "GET",
        timeout: 5000,
      });
      console.log("res data ", response);
      setWorkOrderDetails(response);
    } catch (err) {
      console.error("Error", err);
    }
  };

  useEffect(() => {
    console.log(
      "showDetailsOfWorkorder currentworkorder ",
      showDetailsOfWorkorder,
      currentWorkorderNumber
    );
    // if (showDetailsOfWorkorder && currentWorkorderNumber) {
    callAPIToGetDetailsOfWorkorder();
    // }
  }, [showDetailsOfWorkorder, currentWorkorderNumber]);

  const workOrderConfig = {
    columns: [
      { header: "Work Order Number", accessor: "WO_NO" },
      { header: "Date", accessor: "wo_date", type: "date" },
      { header: "SO No.", accessor: "SO_NO" },
      { header: "Customer Name", accessor: "customer", trim: true },
      { header: "Customer Account", accessor: "ACCOUNT" },
      {
        header: "Action",
        type: "actions",
        headerClassName: "text-center w-[240px]",
        actionLayout: "",
        actions: [
          {
            label: "Approve",
            className:
              "bg-blue-500 hover:bg-gray-400 text-white px-2 py-1 rounded text-xs",
            onClick: (item) => callAPIToChangeStatus(item.WO_NO, "Approved"),
          },
          {
            label: "Reject",
            className:
              "ms-2 bg-red-500 hover:bg-gray-400 text-white px-2 py-1 rounded text-xs",
            onClick: (item) => callAPIToChangeStatus(item.WO_NO, "Rejected"),
          },
          {
            label: "Details",
            className:
              "ms-2 bg-black hover:bg-gray-400 text-white px-2 py-1 rounded text-xs",
            onClick: (item) => clickedOnDetails(item.WO_NO),
          },
        ],
      },
    ],
  };

  return (
    <div className="lg:px-6 px-3 overflow-x-auto lg:w-full w-[100vw]">
      <div className="flex justify-between items-center mb-4 ">
        <h3 className="text-xl font-normal text-gray-800 ">Work Order List</h3>

        <PaginationControls
          setCurrentPageNumber={setCurrentPageNumber}
          currentPageNumber={currentPageNumber}
          data={quotationList}
          itemsPerPage={100}
        />
      </div>

      <div className="w-full overflow-x-auto">
        <ReusableTable
          data={quotationList}
          columns={workOrderConfig.columns}
          currentUserAccessGroup={currentUserAccessGroup}
        />
      </div>
      {loading ? (
        <p className="inset-0 fixed flex justify-center items-center">
          Loading quotations... <CircularProgress size={24} />
        </p> // Show loader while fetching
      ) : (
        <ul></ul>
      )}

      {showDetailsOfWorkorder && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
          style={{ zIndex: 70 }}
        >
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <div className="flex justify-between">
              <h4>Work Order Details</h4>
              <button
                className="bg-black text-white px-4 py-1"
                onClick={() => closePopupClicked()}
              >
                Close
              </button>
            </div>

            <div className="mt-4">
              <p>Code</p>
              <p style={{ color: "#787676" }}>{workOrderDetails[0]?.Code}</p>
            </div>

            <div className="mt-2">
              <p>Description</p>
              <p style={{ color: "#787676" }}>
                {workOrderDetails[0]?.Description}
              </p>
            </div>

            <div className="mt-2">
              <p>Quantity</p>
              <p style={{ color: "#787676" }}>{workOrderDetails[0]?.Qty}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkOrderApprovalListViewFull;
